import { DatePicker, Select, Space } from 'antd';
import moment from 'moment';
import style from './SwitchablePicker.module.scss';
const { Option } = Select;

export type PickerType = 'time' | 'date' | 'week' | 'month' | 'quarter' | 'year' | undefined;

export interface SwitchablePicker {
  type: PickerType;
  setType: (value: PickerType) => void;
  dateTime: string;
  setDateTime: (value: string) => void;
}

export default function SwitchablePicker(props: SwitchablePicker) {
  const { type, setDateTime, setType, dateTime } = props;

  const onChange = async (values: moment.Moment | null) => {
    const day = moment(values).format('YYYY-MM-DD');
    setDateTime(day);
  };

  const disabledDate = (current: any) => {
    return current && current > moment().endOf('day');
  };

  return (
    <Space>
      <Select className={style.custom_select} value={type} onChange={setType}>
        <Option value="date">Date</Option>
        <Option disabled value="week">
          Week
        </Option>
        <Option value="month">Month</Option>
        <Option disabled value="quarter">
          Quarter
        </Option>
        <Option disabled value="year">
          Year
        </Option>
      </Select>
      <DatePicker
        disabledDate={disabledDate}
        picker={type}
        value={moment(dateTime)}
        onChange={(value) => onChange(value)}
        className={style.custom_date_picker}
      />
    </Space>
  );
}
